import { Result, ResultProps } from 'antd'

import styles from './ResultWithIllustration.module.css'

type ResultWithIllustrationProps = ResultProps
export function ResultWithIllustration({
  ...props
}: ResultWithIllustrationProps) {
  return <Result className={styles.root} {...props} />
}
